import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CardWithRadioButtons from '../../../../components/common/CardWithRadioButtons';
import { IS_TAB } from '../../../../utils/common';
import Carousel from '../../../../components/common/Carousel';
import GridLayout from '../../../../components/common/GridLayout';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';

const Armour = ({
  options,
  updatePartsConfig,
  selectedPart,
  selectedCategory,
  removePartConfig,
  availableCategories
}) => {
  const { ref: cardRef, width: itemWidth } = useCarouselItemConfig();
  const [armours, setArmours] = useState(options);

  const title = availableCategories.find(cat => cat.name === selectedCategory)
    .label;

  useEffect(() => {
    setArmours(options);
  }, [options, selectedCategory]);

  const groups = ['Knox', 'D3O', 'KnoxBack', 'D3OBack', 'knoxChest', 'NA'];

  const getGroupData = group => {
    if (armours[0] && armours[0].configData.groupKey)
      return armours.filter(o => o.configData.groupKey === group);
    else return null;
  };

  const renderArmours = groups.map(group => {
    const data = getGroupData(group);

    if (!data || data.length === 0) return;

    return (
      <div className="armour_item" ref={cardRef}>
        <CardWithRadioButtons
          imageUrl={data[0].configData.groupImg}
          options={data}
          selectedPart={selectedPart}
          onChange={index => {
            if (!data[index].partId) {
              removePartConfig(selectedCategory);
            } else updatePartsConfig(data[index]);
          }}
        />
      </div>
    );
  });

  return (
    <div className="armour">
      <h6 className="armour_title">{`Armour for the ${title}`}</h6>
      {IS_TAB ? (
        <Carousel
          itemWidth={itemWidth || 148}
          noOfItems={armours && armours.length}
        >
          {renderArmours}
        </Carousel>
      ) : (
        <GridLayout
          columns={3}
          className="armour_grid"
          columnsWidth={115}
          alignCenter
        >
          {renderArmours}
        </GridLayout>
      )}
    </div>
  );
};

Armour.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object,
  selectedPart: PropTypes.string
};

export default Armour;
